/** The custom-property reads that `styles.ts` and `polish.ts` both spell out.
 *
 * Each is `var(--hm-*, fallback)` with the fallback the theme declares, so a
 * screen mounted outside `<GameTheme>` still renders in the kit's colours. The
 * two sheets used to carry private copies of these six; a fallback edited in
 * one and not the other would have split the palette between the shared rules
 * and the polish that overrides them. `styles.ts` keeps the tokens only it
 * reads.
 */

export const G3 = "var(--hm-gold-3, #d9b25a)";
export const G2 = "var(--hm-gold-2, #a8801f)";
export const G1 = "var(--hm-gold-1, #6b4d15)";
export const G0 = "var(--hm-gold-0, #2f2109)";
export const FAINT = "var(--hm-text-faint, #8a7a5d)";
export const FDISP = "var(--hm-font-display, 'Palatino Linotype', 'Book Antiqua', Palatino, Georgia, serif)";
